<template>
  <div class="form_container content-box login">

        <VueForm
          v-if="isFormShow && !isFormLoading && formObj"
          v-model="formObj.formData"
          :key="formRenderKey"
          :schema="formObj.schema"
          :ui-schema="formObj.uiSchema"
          @on-submit="handleFormSubmit"
            :show-submit="true"
          :error-schema="formObj.errorSchema"
          :show-reset="true"
          :formFooter="{
            okBtn: this.$t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.FORM_FOOTER.OK_BTN'),
            cancelBtn: this.$t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.FORM_FOOTER.CANCEL_BTN'),
          }"
        >
        </VueForm>
      <div class="form_card">
        <div v-if="customError" class="custom_error">
          <Label :title="customError" :colorScheme="'alert'" />
        </div>
      </div>

      <div v-if="!isFormShow" class="form_success mt_20">
        <h2 class="page-title">{{formObj.schema.title}}</h2>
        <p class="paragraph">{{ $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.SUCCESS.SUCCESS_MSG') }}</p>
        <woot-button
          class="clear backBtn"
          color-scheme="primary"
          variant="clear"
          size="small"
          @click="onReSubmitForm"
        >
            {{ $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.SUCCESS.BACK_FORM') }}
        </woot-button>
      </div>
      <div v-if="!isFormLoading && !formObj" class="form_success mt_20">
        <h2 class="page-title"> {{ conflict.isConflict ? $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.CONFLICT.TITLE') : $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.NOT_FOUND.TITLE') }}</h2>
        <p class="paragraph">{{ conflict.isConflict? $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.CONFLICT.DESCRIPTION') + conflict.email: $t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.NOT_FOUND.DESCRIPTION') }}</p>
      </div>
      <SpinnerWithMessage
        :isLoading="isFormLoading"
        :message="$t('CAMPAIGN.CAMPAIGN_FORMS.SHOW.LOADING_MSG')"
        className=""
    />
  </div>
</template>


<script>
// call /public/api/v1/campaign_forms/:slug
import CampaignPublicAPI from "dashboard/api/public/campaign.js"
import alertMixin from 'shared/mixins/alertMixin';
import VueForm from '@lljj/vue-json-schema-form';
import debounce from 'lodash/debounce';
import SpinnerWithMessage from "shared/components/SpinnerWithMessage.vue";
import Label from 'dashboard/components/ui/Label';

export default {
  components: {
    VueForm,
    SpinnerWithMessage,
    Label,
  },
  mixins: [alertMixin,],
  data(){
    return {
      isFormLoading:false,
      formObj: {
        formData:{},
        schema:{},
        uiSchema:{},
      },
      draftSaved: false,
      // draftId: null,
      savingDraft: false,
      isFormShow: true,
      customError:null,
      formRenderKey: 0,
      conflict:{
        isConflict:false,
        email: "",
      }

    }
  },
  mounted(){
    this.fetchCampaignFormRecord();

    // Wrap checkAndSaveDraft with debounce
    this.debouncedCheckAndSaveDraft = debounce(this.checkAndSaveDraft, 10*1000);
  },
  // activated(){
  //   this.fetchCampaignFormRecord();
  // },
  watch: {
    // Watch the first 3 fields
    'formObj.formData.email': {
      handler(newVal) {
         if (newVal) this.debouncedCheckAndSaveDraft();
      }
    },
    'formObj.formData.phone_number': {
      handler(newVal) {
         if (newVal) this.debouncedCheckAndSaveDraft();
      }
    },
    'formObj.formData.fullname': {
      handler(newVal) {
         if (newVal) this.debouncedCheckAndSaveDraft();
      }
    },
  },
  methods:{
    async fetchCampaignFormRecord(){
      try {
        this.isFormLoading = true;
        this.conflict.isConflict = false;
        this.conflict.email = '';
        const {data} = await CampaignPublicAPI.fetchCampaignFormBySlug(this.$route.params.form_slug,this.$route.query);
        this.formObj = data;
      } catch (error) {
        this.formObj = null;
        console.log(error);
        if (error.response) {
          if (error.response.status === 409){
            this.conflict.isConflict = true;
            this.conflict.email = error.response.data.email;
          }else{
            // this.showErrAlert(error,"Something went wrong!");
          }
        }else{
          // this.showErrAlert(error,"Something went wrong!");

        }
      }finally{
        this.isFormLoading = false;
      }
    },
    async handleFormSubmit(formData, isDrafted = false) {
      try {
        this.customError = null;
        const email = formData?.email || "";

        const payload = new FormData();
        payload.append("respondent_email", email);

        // Shallow copy of formData, but replace File with filename
        const formDataForJson = {};

        for (const [key, value] of Object.entries(formData)) {
          if (value instanceof File) {
            // 🆕 new upload
            formDataForJson[key] = value.name;
            payload.append(`${key}_file`, value);
          } else if (Array.isArray(value) && value.length && value[0] instanceof File) {
            // 🆕 multi-file upload
            formDataForJson[key] = value.map(f => f.name);
            value.forEach((f, i) => {
              payload.append(`${key}_file_${i}`, f);
            });
          } else if (typeof value === "string" && value.startsWith("http")) {
            // 📝 existing file URL from backend (editing mode)
            formDataForJson[key] = value;
            // ⚠️ don't append file, just keep URL
          } else {
            // normal field
            formDataForJson[key] = value ?? "";
          }
        }

        // Append JSON data
        payload.append("response_data", JSON.stringify(formDataForJson));
        payload.append("completed", isDrafted ? false : true);

        const { data } = await CampaignPublicAPI.createCampaignFormResponse(
          this.$route.params.form_slug,
          payload
        );

        if (isDrafted) {
          this.draftSaved = true;
        } else {
          this.draftSaved = false;
          this.isFormShow = false;
          this.showAlert("Submit successful");
        }
      } catch (error) {
        console.error(error);
        this.showErrAlert(error, "Something went wrong!");
        this.customError = error?.response?.data?.error || "Something went wrong!";
      } finally {
        this.formRenderKey++;
      }
    },
    async checkAndSaveDraft() {
       // Prevent concurrent saves
      if (this.savingDraft) return;

      // Only save draft once when all 3 fields have values
      if (!this.draftSaved &&
          this.formObj.formData.email &&
          this.formObj.formData.phone_number &&
          this.formObj.formData.fullname) {
          // this.saveDraft();
          this.savingDraft = true;
           try {
          await this.handleFormSubmit(this.formObj.formData, true);
          this.draftSaved = true;   // Mark draft saved only on success
        } catch (e) {
          // You can show error or retry logic
          console.error('Draft save failed:', e);
        } finally {
          this.savingDraft = false;
        }
      }
    },
    onReSubmitForm(){
      this.isFormShow = true;
      this.draftSaved = false;
      this.formObj.formData = {}
    },

  },
}
</script>


<style scoped lang="scss">
.form_container{
  max-width: 75rem;
  margin: auto;
  margin-bottom: 13rem;
}
.form_success{
  border: 1px solid #eee;
  padding: 30px;
  border-radius: 10px;
  max-width: 50rem;
  margin: auto;
}

.form_card{
  position: relative;
  .custom_error{
    position: absolute;
    bottom: 30px;
    left: 0;
    width: fit-content;
    height: 20px;
  }
}
</style>

<style>
.form_container .el-select .el-input input[readonly="readonly"] {
  background-color: #fff ;
}
.form_container .el-input__prefix, .form_container .el-input__suffix {
  height: auto;
}
.form_container .form_success .backBtn{
  padding: 0 !important;
}
</style>
